export enum PaymentStatus {
  scheduled = 'scheduled',
  pending = 'pending',
  successful = 'successful',
  failed = 'failed',
  canceled = 'canceled',
  review = 'review',
  rejected = 'rejected',
}

export const GROUP_PAYMENT_OBJECT_TYPE = 'group-payment';

export function localizePaymentStatus(status: PaymentStatus): string {
  let value: string = '';

  switch (status) {
    case PaymentStatus.scheduled:
      value = $localize`:General|Payment Status Scheduled title@@general-payment-status-scheduled-title:Scheduled`;
      break;
    case PaymentStatus.pending:
      value = $localize`:General|Payment Status Pending title@@general-payment-status-pending-title:Pending`;
      break;
    case PaymentStatus.successful:
      value = $localize`:General|Payment Status Successful title@@general-payment-status-successful-title:Successful`;
      break;
    case PaymentStatus.failed:
      value = $localize`:General|Payment Status Failed title@@general-payment-status-failed-title:Failed`;
      break;
    case PaymentStatus.canceled:
      value = $localize`:General|Payment Status Canceled title@@general-payment-status-canceled-title:Canceled`;
      break;
    case PaymentStatus.review:
      value = $localize`:General|Payment Status Review title@@general-payment-status-review-title:In review`;
      break;
    case PaymentStatus.rejected:
      value = $localize`:General|Payment Status Rejected title@@general-payment-status-rejected-title:Rejected`;
      break;
  }

  return value;
}

export function mobilePaymentStatusIcon(paymentStatus: PaymentStatus): string {
  let icon: string = 'maximize';
  switch (paymentStatus) {
    case PaymentStatus.scheduled:
      icon = 'schedule';
      break;
    case PaymentStatus.pending:
      icon = 'cached';
      break;
    case PaymentStatus.successful:
      icon = 'check_circle_outline';
      break;
    case PaymentStatus.failed:
      icon = 'error_outline';
      break;
    case PaymentStatus.canceled:
      icon = 'highlight_off';
      break;
    case PaymentStatus.review:
      icon = 'preview';
      break;
    case PaymentStatus.rejected:
      icon = 'report_gmailerrorred';
      break;
  }

  return icon;
}

export class PaymentGroup {
  public id: string;
  public paymentId?: string;
  public paymentPrice?: number;
  public paymentSessionId?: string;
  public paymentInvoiceId?: string;
  public paymentPageUrl?: string;
  public paymentStatus?: PaymentStatus;
  public paymentAt?: Date;
  public paymentName?: string;
  public paymentNotConfigured?: boolean;

  constructor(id: string) {
    this.id = id;
  }

  public static parse(dto: PaymentGroupDto): PaymentGroup {
    const group = new PaymentGroup(dto.id);

    if (dto.payment_id) group.paymentId = dto.payment_id;
    if (dto.payment_price) group.paymentPrice = dto.payment_price;
    if (dto.payment_session_id) group.paymentSessionId = dto.payment_session_id;
    if (dto.payment_invoice_id) group.paymentInvoiceId = dto.payment_invoice_id;
    if (dto.payment_page_url) group.paymentPageUrl = dto.payment_page_url;
    if (dto.payment_status) group.paymentStatus = dto.payment_status;
    if (dto.payment_at) group.paymentAt = new Date(dto.payment_at);
    if (dto.payment_not_configured) group.paymentNotConfigured = dto.payment_not_configured;
    if (dto.name) group.paymentName = dto.name;

    return group;
  }
}

export interface PaymentDetails {
  payment_id?: string;
  payment_price?: number;
  payment_session_id?: string;
  payment_invoice_id?: string;
  payment_page_url?: string;
  payment_status?: PaymentStatus;
  payment_at?: number;
  payment_not_configured?: boolean;
}

export interface PaymentGroupDto extends PaymentDetails {
  id: string;
  name?: string;
}
